import dayjs from 'dayjs'
import createModel from 'utils/model'
import {byUser, byChannel} from 'crm/services/stat-customer-distribution'
import {parseCustomerChannels} from 'crm/utils/customer'
import constants from 'crm/common/constants'

const {dateFormat} = constants

function getInitialParams() {
    return {
        department_id: undefined,
        user_id: undefined,
        channel_id: undefined, // 渠道 id
        group_id: undefined, // 分组id
        time_from: dayjs().subtract(6, 'days').format(dateFormat),
        time_to: dayjs().format(dateFormat),
    }
}

export default createModel({
    namespace: 'crm_statCustomerDistribution',

    state: {
        params: getInitialParams(),
        usersOriginData: [],
        customerChannelsOriginData: [],
    },

    effects: {
        *byUser({payload}, {call, put}) {
            const res = yield call(byUser, payload)
            const users = res?.data || []
            yield put({
                type: 'setProperty',
                payload: {
                    usersOriginData: users,
                },
            })
        },
        *byChannel({payload}, {call, put}) {
            const res = yield call(byChannel, payload)
            const parsedChannels = parseCustomerChannels(res?.data)
            yield put({
                type: 'setProperty',
                payload: {
                    customerChannelsOriginData: parsedChannels,
                },
            })
        },
    },

    reducers: {},
})
